import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  login,
  logout,
  isStaffLoggedIn,
  getAdminEmail,
  canManageProducts,
  canManageTeam,
} from "../auth";
import styles from "./admin.module.css";

const Admin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [loggedIn, setLoggedIn] = useState(isStaffLoggedIn());

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setLoading(true);
    try {
      const { role } = await login(email.trim(), password);
      setLoggedIn(true);
      // Viewers can't add products — send them to the product list instead
      navigate(role === "viewer" ? "/all-item" : "/admin-dashboard");
    } catch (err) {
      setErrorMsg(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    logout();
    setLoggedIn(false);
    setEmail("");
    setPassword("");
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.brand}>
          <span className={styles.eyebrow}>Admin</span>
          <h1 className={styles.wordmark}>LORMAMI</h1>
        </div>

        {loggedIn ? (
          <div className={styles.signedIn}>
            <p className={styles.signedInNote}>
              Signed in as <strong>{getAdminEmail()}</strong>
            </p>
            {canManageProducts() && (
              <Link to="/admin-dashboard" className={styles.linkBtn}>
                Add a Product
              </Link>
            )}
            <Link to="/all-item" className={styles.linkBtnGhost}>
              {canManageProducts() ? "Manage All Products" : "View All Products"}
            </Link>
            {canManageTeam() && (
              <Link to="/admin-team" className={styles.linkBtnGhost}>
                Manage Team
              </Link>
            )}
            <button type="button" className={styles.logout} onClick={handleLogout}>
              Log out
            </button>
          </div>
        ) : (
          <form className={styles.form} onSubmit={handleLogin}>
            {errorMsg && <p className={styles.error}>{errorMsg}</p>}

            <div className={styles.field}>
              <label className={styles.label} htmlFor="admin-email">
                Email
              </label>
              <input
                id="admin-email"
                className={styles.input}
                type="email"
                autoComplete="username"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className={styles.field}>
              <label className={styles.label} htmlFor="admin-password">
                Password
              </label>
              <input
                id="admin-password"
                className={styles.input}
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <button className={styles.submit} type="submit" disabled={loading}>
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        )}

        <Link to="/" className={styles.backLink}>
          ← Back to store
        </Link>
      </div>
    </div>
  );
};

export default Admin;
